import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { AvailableGatesDoughnutChartComponent } from "./components/available-gates-doughnut-chart/available-gates-doughnut-chart.component";
import { GatePositionChartComponent } from "./components/gate-position-chart/gate-position-chart.component";
import { GateFaultFrequencyComponent } from "../../../../shared/widgets/gate-fault-frequency/gate-fault-frequency.component";
import { TranslateModule } from "@ngx-translate/core";
import { EnergyLossYearlyChartComponent } from "../../../../shared/widgets/energy-loss-yearly-chart/energy-loss-yearly-chart.component";

import { first } from "rxjs";
import { SimplebarAngularModule } from "simplebar-angular";
import { AuthService } from "../../../../services/api/auth/auth.service";
import { User } from "../../../../models/api/user";
import { StatisticsService } from "./facade/global-statistics.service";

@Component({
  standalone: true,
  selector: "app-global-statistics",
  imports: [
    AvailableGatesDoughnutChartComponent,
    GatePositionChartComponent,
    GateFaultFrequencyComponent,
    TranslateModule,
    EnergyLossYearlyChartComponent,
    SimplebarAngularModule,
  ],
  templateUrl: "./global-statistics.component.html",
  styleUrl: "./global-statistics.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [StatisticsService],
})
export class GlobalStatisticsComponent implements OnInit, OnDestroy {
  public statisticsFacade = inject(StatisticsService);
  private authService = inject(AuthService);

  ngOnInit() {
    this.authService
      .getAuthenticatedUser()
      .pipe(first())
      .subscribe((user: User) => {
        const customerId = user.customer?.id;
        if (customerId) {
          this.statisticsFacade.loadInitialState(customerId);
        }
      });
  }

  ngOnDestroy() {
    this.statisticsFacade.destroy();
  }
}
